class CustomBundles {
  constructor() {
    this.fetchBundles();
  }

  fetchBundles() {
  }
}

export default CustomBundles;